var map = {
	"./AppStore.jpg": 2544,
	"./EpicGames.jpg": 5178,
	"./GOG.jpg": 7656,
	"./GooglePlay.jpg": 6618,
	"./NintendoStore.jpg": 858,
	"./OIP.jpg": 4168,
	"./PlayStationStore.jpg": 75,
	"./R.jpg": 5853,
	"./Steam.jpg": 5280,
	"./Untitled Diagram - diagrams.net_files/404-error-page-not-found.jpg": 3024,
	"./Untitled Diagram - diagrams.net_files/My video store game(1).jpg": 9045,
	"./Untitled Diagram - diagrams.net_files/My video store game.jpg": 8076,
	"./Untitled Diagram - diagrams.net_files/bandicam 2023-02-02 22-16-15-346(1).jpg": 5665,
	"./Untitled Diagram - diagrams.net_files/bandicam 2023-02-02 22-16-15-346.jpg": 4105,
	"./XboxStore.jpg": 8692,
	"./itch.io.jpg": 8455,
	"./playstation-store.jpg": 2373,
	"./th (1).jpg": 4161,
	"./th.jpg": 3805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7829;